module.exports = __webpack_public_path__ + "img/target-0.af6e9121.png";